import React from 'react';
import Clipboard from 'clipboard';
import ReactTooltip from 'react-tooltip';

interface ICopyToClipboardButtonProps {
	textToCopy: string;
	className?: string;
	copiedText?: string;
}

export class CopyToClipboardButton extends React.Component<ICopyToClipboardButtonProps> {
	private copyToClipboardButton?: HTMLButtonElement | null;
	private clipboard: Clipboard = null;

	componentDidMount() {
		this.clipboard = new Clipboard(this.copyToClipboardButton, {
			text: () => this.props.textToCopy,
		});
	}

	componentWillUnmount() {
		this.clipboard.destroy();
	}

	render() {
		const { copiedText, className, children } = this.props;
		return (
			<button
				ref={button => (this.copyToClipboardButton = button)}
				data-tip={copiedText ? copiedText : 'Copied'}
				data-event="click"
				data-event-off="mouseleave"
				data-delay-hide="2000"
				data-effect="solid"
				data-place="top"
				data-border
				className={className}
			>
				{children ? children : 'Copy'}
				<ReactTooltip />
			</button>
		);
	}
}
